import { DocumentEvents } from "./../../helpers/document-events";
import { CICListTabView } from "./cic-list-tab";
import { CaseRelationModel } from "./../../models/case-relation";
import { CiteLineListTabModel } from "./../../models/tabs/citeline-list-tab";
import { AppEvents } from "./../../../app-events";
import { CitelineView } from "./../citeline";
import { SortableCollection, SortDictionary } from "./../../collections/sortable-collection";
import { ISorter } from "./../../interfaces/sorter";
import { GenericTabModel } from "./../../models/tabs/generic-tab";
import { ListControlsView } from "./list-controls";
import { GenericListTabView } from "./generic-list-tab";
import { GenericListView } from "./generic-list";
import { transient, Container } from "aurelia-dependency-injection";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import { ListTabModel } from "../../models/tabs/list-tab";
import { CitelineModel } from "../../models/citeline";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

const template = require<string>("./generic-list-tab.html");

const dom = {
    CITELINE_BUTTON: ".citeline-button",
    CITELINE_CLOSE: ".citeline-closer",
};
@transient()
@backboneViewProperties({
    tagName: "div",
    template: template
})
export class CiteLineListTabView extends CICListTabView {

    public model: CiteLineListTabModel;
    private citelineRegion: Marionette.Region;
    private clickedBefore = false;

    public constructor(options?: any) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public onShow() {
        super.onShow();
        this.setupCiteLineButton();
    }

    public setupModelListeners(): void {
        super.setupModelListeners();
        this.listenTo(this.model.State, "change:CiteLineEngaged", this.openCiteLine);
    }

    public regions() {
        const superRegions = super.regions();
        const myRegions = {
            citelineRegion: ".citeline-region"
        };
        return _.extend(superRegions, myRegions);
    }

    public events(): Backbone.EventsHash {
        const events = super.events();
        events[`click ${dom.CITELINE_BUTTON}`] = (e) => this.citeLineClick(e);
        events[`click ${dom.CITELINE_CLOSE}`] = (e) => this.closeCiteline ();
        return events;
    }

    public citeLineClick(e: JQueryEventObject): void {
        if (this.model.State.CiteLineEngaged || $(e.currentTarget).hasClass("disabled")) {
            return;
        }
        this.model.State.CiteLineEngaged = true;
    }
    private setupCiteLineButton() {
        const anyVisibleCases = this.model.RelationCollection.any((s: CaseRelationModel) => s.IsActuallyVisible && s.CitedReferences > 0);
        this.$(dom.CITELINE_BUTTON).toggle(anyVisibleCases);
        if (this.getIEVersion() <= 9) {
            this.$(dom.CITELINE_BUTTON).html(`Citeline Unavailable`);
            this.$(dom.CITELINE_BUTTON).attr("title", "This feature is not supported in Internet Explorer 9 or below. Update your browser to view Citeline");
            this.$(dom.CITELINE_BUTTON).css("padding-right", "12px");
            this.$(dom.CITELINE_BUTTON).addClass("disabled");
            return;
        }
    }

    private openCiteLine(model, prop) {
        if (!this.model.State.CiteLineEngaged) { // this method triggers on change to CiteLineEngaged. If its false then we're closing not opening and don't want to run this code
            return;
        }
        this.updateCitelineLoadingButton();
        this.appEvents.trigger(AppEvents.CiteLineEngaged);
        const citelineTimer = setTimeout(() => this.showCitelineLoadingMessage(), 5000);
        this.loadCiteline().then(() => {
            this.model.Data.trigger(DocumentEvents.CiteLineEngaged);
            clearTimeout(citelineTimer);
            this.hideCitelineLoadingMessage();
        }).catch((e) => {
            clearTimeout(citelineTimer);
            this.hideCitelineLoadingMessage();
        });
    }
    /** Show tooltip when its taking 5+ seconds */
    private showCitelineLoadingMessage() {
        this.$(dom.CITELINE_BUTTON).attr("title", "This may take a few moments").attr("data-placement", "bottom").tooltip("show");
    }

    private hideCitelineLoadingMessage() {
        this.$(dom.CITELINE_BUTTON).attr("title", "See all citing paragraphs").tooltip("destroy");
    }

    /** disable and start loading animation on citeline button */
    private updateCitelineLoadingButton() {
        const $button = this.$(dom.CITELINE_BUTTON);
        $button.addClass("disabled");
        $button.find(".citeline-icon").hide();
        $button.find(".citeline-loading").css("display", "inline-block");
    }

    private buildCitelineRequestFromSentenceQuoteList($list: JQuery) {
        // Create a Citeline request from the quoting paragraphs popover
        const requestData = {};
        $list.find("li").each((index, elem) => {
            const id = parseInt($(elem).attr("data-id"));
            const paranumArray = [];
            $(elem).find(".quoting-para-number a").each((idx, numLink) => {
                const num = parseInt($(numLink).attr("data-para-num"));
                paranumArray.push(num);
            });
            requestData[id] = paranumArray;
        });
        return requestData;
    }

    private loadCiteline(specificData?: any): Promise<any> {
        const citelineView = this.createCitelineView();
        if (!specificData) {
            return citelineView.model.load().then(() => {
                this.makeWayForCiteline();
                this.citelineRegion.show(citelineView);
            });
        } else {
            return citelineView.model.loadSpecific(specificData).then(() => {
                this.makeWayForCiteline();
                this.citelineRegion.show(citelineView);
            });
        }
    }

    private createCitelineView(): CitelineView {
        const citelineModel: CitelineModel = Container.instance.get(CitelineModel);
        const docHolder = (this.model.Data.collection as any).parents[0];
        citelineModel.setData(this.model.RelationCollection, this.model.Data.Id, docHolder);
        const citelineView: CitelineView = Container.instance.get(CitelineView);
        citelineView.model = citelineModel;
        return citelineView;
    }

    private makeWayForCiteline(): void {

        this.$(".analysis-section-content").hide();

    }

    private closeCiteline() {
        this.model.State.CiteLineEngaged = false;
        this.model.Data.trigger(DocumentEvents.CiteLineDisengaged);
        this.appEvents.trigger(AppEvents.CiteLineClosed);

        const region = (this.citelineRegion as any);
        if (!region.currentView) {
            return;
        }
        this.$(".citeline").removeClass("engaged");
        this.$(".analysis-section-content").show();

        const tab = this;
        setTimeout(() =>  {
            tab.$(".document-nav").fadeIn();
            tab.citelineRegion.empty();
            tab.$(dom.CITELINE_BUTTON).removeClass("disabled");
            tab.$(dom.CITELINE_BUTTON).find(".citeline-icon").css("display", "inline-block");
            tab.$(dom.CITELINE_BUTTON).find(".citeline-loading").hide();
        }, (this.model.Data.collection as any).parents[0].Compact ? 0 : 800);
    }
    /** returns IE version, or a massive integer if the browser is not IE */
    private getIEVersion() {
        const myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf("msie") !== -1) ? parseInt(myNav.split("msie")[1]) : 9007199254740991;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/citeline-list-tab.ts